export default __webpack_public_path__ + "static/media/volume_mute.856544ad.webp";